import { PortalWrapper } from 'app/App.styles';
import { Footer } from 'app/core/footer/Footer';
import { AccountsContextProvider } from 'context/accounts/AccountsContextProvider';
import { RolesContextProvider } from 'context/roles/RolesContextProvider';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { AutoDetectActiveAccount, Column, Layout, Loader, Row } from 'shared';
import { useQuery } from 'shared/hooks';

import { AccountContainer } from './account/AccountContainer';
import { AddAccountContainer } from './addAccount/AddAccountContainer';
import { ApplicationContainer } from './application/ApplicationContainer';
import { ApplicationsContainer } from './applications/ApplicationsContainer';
import { DashboardProps } from './Dashboard.types';
import { Header } from './header/Header';
import { SidebarContainer } from './sidebar/SidebarContainer';

export const Dashboard = ({ onFetchAccounts, email, roles }: DashboardProps) => {
  const { response: accountsResponse, loading: accountsLoading, error: accountsError } = useQuery(onFetchAccounts);

  return (
    <RolesContextProvider roles={roles}>
      {accountsLoading && <Loader fullScreen={true} />}
      {accountsError && <Redirect to="/logout" />}

      {accountsResponse && (
        <AccountsContextProvider accounts={accountsResponse.payload}>
          <AutoDetectActiveAccount />
          <Layout header={<Header email={email} />} footer={<Footer />}>
            <Row height="100%">
              <Column>
                <PortalWrapper className="portal">
                  <Row height="100%">
                    <Column size={[12, 4, 4, 3]}>
                      <SidebarContainer />
                    </Column>
                    <Column size={[12, 8, 8, 9]}>
                      <Switch>
                        <Route path="/:accountId/dashboard/:applicationId" component={ApplicationContainer} />
                        <Route path="/:accountId/dashboard" component={ApplicationsContainer} />
                        <Route path="/:accountId/account" component={AccountContainer} />
                        <Route path="/add-account" component={AddAccountContainer} />
                        <Redirect to={`/${accountsResponse.payload[0].uuid}/dashboard`} />
                      </Switch>
                    </Column>
                  </Row>
                </PortalWrapper>
              </Column>
            </Row>
          </Layout>
        </AccountsContextProvider>
      )}
    </RolesContextProvider>
  );
};
